import React from 'react'
import { Request } from 'src/common/components'
import { RequestType } from 'src/common/static'

const Burn: React.FC = () => {
  return <Request type={RequestType.BURN} />
}

export default Burn
